import { LARGEST_PAGE, PageHeader, PhotoModeration, Stack, useApi, useI18n } from '@daghfal/core';
import { useQuery } from '@tanstack/react-query';
import { useMyClasses } from '../myClasses';

/**
 * The photographs this teacher uploaded (GAPS 4.7, decision 2026-10-28 #4): retagged when the wrong child was tagged,
 * recaptioned, or deleted. A colleague's picture is not listed here; the console's gallery holds those.
 *
 * A picture is retagged with the children of the teacher's own classes, never a room they see only as a parent (Q52).
 */
export function MyPhotos() {
  const api = useApi();
  const { t } = useI18n();
  const { mine } = useMyClasses();
  const classIds = new Set(mine.map((klass) => klass.id));

  const children = useQuery({
    queryKey: ['children', { status: 'Active', pageSize: LARGEST_PAGE }],
    queryFn: () => api.children.list({ status: 'Active', pageSize: LARGEST_PAGE }),
  });
  const candidates = (children.data?.items ?? []).filter((child) => child.classId !== null && classIds.has(child.classId));

  return (
    <Stack>
      <PageHeader title={t('photos.mine')} lede={t('photos.mine.lede')} />
      <PhotoModeration query={{ mine: true, pageSize: LARGEST_PAGE }} candidates={candidates} />
    </Stack>
  );
}
